import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { useInterval } from '../../hooks';
import { DRAFT_ORDER_ACTIONS } from '../../store/actions/reducer-actions/draft-orders';
import { USERS_ACTIONS } from '../../store/actions/reducer-actions/users';
import { connect } from '../../utils/redux';
import { NotificationType, sendNotification } from '../../utils/toast';
import Paths from '../routes/paths';

const PendingDraftOrderNotifier = ({
  usersState,

  getMultiAccountDraftOrderCounts,
  setMultiAccountCurrentUser,
}) => {
  const history = useHistory();

  const currentUser = useMemo(() => usersState.currentUser, [usersState]);

  const currentCustomer = useMemo(() => {
    if (currentUser) {
      return currentUser.customerID;
    }

    return null;
  }, [currentUser, currentUser?.customerID]);

  const resetMultiAccountCurrentUser = () => {
    history.push(Paths.Home());
    setMultiAccountCurrentUser(null);
  };

  const getCounts = useCallback(async () => {
    if (
      currentUser &&
      currentUser.canManageDraftOrders &&
      currentUser.isMultiAccount
    ) {
      const { counts } = await getMultiAccountDraftOrderCounts();

      const otherAccounts = counts.filter(
        ({ customerCode, count }) =>
          customerCode !== currentCustomer && count > 0,
      );

      const totalCount = otherAccounts.reduce(
        (total, { count }) => total + count,
        0,
      );

      const pluralCount = totalCount > 1 ? 's' : '';
      const pluralAccounts = otherAccounts.length > 1;

      if (totalCount > 0) {
        sendNotification({
          type: NotificationType.INFO,
          id: 'pending-draft-orders-notification',
          title: `Projet${pluralCount} en attente de validation`,
          description: `Vous avez ${totalCount} projet${pluralCount} de commande en attente de validation sur ${
            pluralAccounts ? 'des' : 'un'
          } autre${pluralAccounts ? 's' : ''} compte${
            pluralAccounts ? 's' : ''
          }.`,
          duration: Infinity,

          action: {
            label: 'Changer de compte',
            onClick: resetMultiAccountCurrentUser,
          },
        });
      }
    }
  }, [currentCustomer, currentUser, currentUser?.canManageDraftOrders]);

  useInterval(getCounts, 60_000);

  return null;
};

PendingDraftOrderNotifier.propTypes = {
  usersState: PropTypes.objectOf(PropTypes.any).isRequired,

  getMultiAccountDraftOrderCounts: PropTypes.func.isRequired,
  setMultiAccountCurrentUser: PropTypes.func.isRequired,
};

export default connect(state => ({ usersState: state.users }), {
  ...USERS_ACTIONS,
  ...DRAFT_ORDER_ACTIONS,
})(PendingDraftOrderNotifier);
